import { ReactComponent as StarIcon } from 'assets/star_required_icon.svg';
import { useFormContext } from 'react-hook-form';
import { IInputCheckboxProps } from './types';
import { getErrorText } from 'utils/getErrorText';
import styles from './inputCheckbox.module.scss';
import { FC } from 'react';
import { ErrorIcon } from 'components/Core/ErorrIcon/ErrorIcon';
import { observer } from 'mobx-react-lite';

export const InputCheckbox: FC<IInputCheckboxProps> = observer(
  ({
    required = false,
    stylesProp,
    name,
    label,
    labelText,
    errorText,
    isRemoveMargin = false,
    disabled = false,
    onBlur,
    onFocus,
    showErrorIcon = true,
    defaultChecked = false,
    checkBoxSize = 'small',
    checkBoxStyles,
    checkBoxPosition = 'left',
  }) => {
    const formContext = useFormContext();

    const { register, getFieldState } = formContext;

    return (
      <div className={styles.inputWrapper} style={isRemoveMargin ? { marginBottom: 0 } : {}}>
        {label && <p className={styles.subtitle}>{label}</p>}
        <label className={styles.checkboxWrap} style={checkBoxPosition === 'right' ? { paddingRight: 35 } : {}}>
          {required && <StarIcon className={styles.requiredIcon} />}
          {labelText && <p>{labelText}</p>}
          <input
            type='checkbox'
            style={getFieldState(name).error ? { ...stylesProp, borderColor: '#E73331' } : { ...stylesProp }}
            className={`${styles.input}`}
            disabled={disabled}
            {...register(name, {
              required: required,
              onBlur: onBlur,
            })}
            onFocus={(e) => {
              onFocus && onFocus(e.target.value);
            }}
            defaultChecked={defaultChecked}
          />
          <span
            className={`${styles.checkmark} ${styles[checkBoxSize]} ${disabled && styles.disabled} ${
              (getFieldState(name).error && styles.error, styles[checkBoxPosition])
            }`}
            style={{ ...checkBoxStyles }}
          />
        </label>
        {getFieldState(name).error && showErrorIcon && (
          <ErrorIcon
            name={name}
            message={getErrorText((getFieldState(name).error?.type as string) || '', {
              errorText,
            })}
          />
        )}
      </div>
    );
  }
);
